// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__3DFWg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
}

.styles_btnContainer__Bup1b {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.styles_line__containerModal__IX5b- {
    display: flex;
    gap: 1rem;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Parametros/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.btnContainer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.line__containerModal {\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__3DFWg`,
	"btnContainer": `styles_btnContainer__Bup1b`,
	"line__containerModal": `styles_line__containerModal__IX5b-`
};
export default ___CSS_LOADER_EXPORT___;
